import React ,{useEffect} from "react";
import {BrowserRouter as Router, Routes, Route , useLocation } from "react-router-dom";
import {Links} from './PathLink'

import Home from "../pages/Home";
import UserLogin from '../pages/auth/UserLogin';
import UserRegister from '../pages/auth/UserRegister';
import PageNotFound from '../pages/common/PageNotFound';
import MyDashboard  from '../pages/dashboard/dashboard';
import MyForums from "../pages/dashboard/my-forums";
import MyScreens from "../pages/dashboard/my-screens";
import MyFollowedScreens from "../pages/dashboard/my-followed-screens";
import MySmartPortfolio from "../pages/dashboard/my-smart-portfolio";
import {Authentication} from "./Authentication";
import Profile from '../pages/auth/Profile';
import Logout from "../pages/common/Logout";
import CompanyDetails from "../pages/CompanyDetails";
import ScreenDetails from "../pages/ScreenDetails";
import Screens from "../pages/Screens";
import SectorDetails from "../pages/SectorDetails";
import Sectors from "../pages/Sectors";
import Ipo from "../pages/Ipo";
import Indices from "../pages/Indices";
import IndicesDetails from "../pages/IndicesDetails";
import SuperInvestorList from '../pages/superinvestor/SuperInvestorsList';
import InvestorDetails from '../pages/superinvestor/investorDetails';

import Contact from "../pages/static-pages/contact";
import About from "../pages/static-pages/About";
import Privacy from '../pages/static-pages/Privacy'
import Terms from '../pages/static-pages/Terms'
import AddScreens from "../pages/screens/add-screens";
import SME from "../pages/SME";
import SMECat from "../pages/SMECat";

import AddDemoPortFolio from '../pages/demoportfolio/add-demoportfolio';
import DemoPortfolioDetails from '../pages/demoportfolio/demoportfolioDetails';
//add this 12-1-26

/* start add this 10-2-26 */
import MostActiveStocks from "../pages/stock-action/most-active";
import TopGainers from "../pages/stock-action/top-gainers";
import TopLosers from "../pages/stock-action/top-losers";
/* end add this 10-2-26 */
import ForumHome  from "../pages/forum/ForumHome";
import ForumDetails from "../pages/forum/ForumDetails";
import Demoportfolio from "pages/demoportfolio/demoportfolio";

import Disclaimer from '../pages/static-pages/Disclaimer'
import ForumRules from '../pages/static-pages/ForumRules'

//add this line 13/4/2026 
import AllConcalls from "../pages/concall/all-concalls";

import StockAnalysisVideo from "../pages/StockAnalysisVideo";

// basename='/stockmarket/'
//"homepage": "https://www.bullscreen.in/",
/*  "homepage": "https://sisnolabs.com/stockmarket/",
*/
const RoutePath = () => {
    const ScrollHandler = () => {
        const { pathname } = useLocation();
        
        useEffect(() => {
            // Skip scroll for company pages
            if (pathname.startsWith("/company/")) {
                return;
            }
            window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth", // change to "smooth" if you want animation
            });
        }, [pathname]);

        return null;
    };
    
    return (        
        <Router basename='/' >
        <ScrollHandler />
            <Routes>
               {/*<Route path='/' element={<Comingsoon />} />*/}
                <Route path='/' element={<Home />} />
                <Route path={Links.USER_LOGIN} element={<UserLogin />} />
                <Route path={Links.USER_SIGNUP} element={<UserRegister />} />
                <Route path={Links.MYDASHBOARD} element={<Authentication><MyDashboard /></Authentication>} />
                <Route path={Links.PROFILE} element={<Authentication><Profile /></Authentication>} />
                <Route path={Links.MYFORUMS} element={<Authentication><MyForums /></Authentication>} />
                <Route path={Links.MYSCREENS} element={<Authentication><MyScreens /></Authentication>} />
                <Route path={Links.MYFOLLOWEDSCREENS} element={<Authentication><MyFollowedScreens /></Authentication>} />
               <Route path={Links.MYSMARTPORTFOLIO} element={<Authentication><MySmartPortfolio /></Authentication>} />
               
                <Route path={Links.LOGOUT} element={<Logout />} />
                <Route path={`${Links.COMPANY}/:slug`} element={<CompanyDetails />} />
                <Route path={`${Links.COMPANY}/:slug/:type`} element={<CompanyDetails />} />
                <Route path={`${Links.SCREENS}`} element={<Screens />} />
                <Route path={`${Links.SCREENS}/:slug`} element={<ScreenDetails />} />
                <Route path={`${Links.SECTORS}/:slug`} element={<SectorDetails />} />
                <Route path={`${Links.SECTORS}`} element={<Sectors />} />
                <Route path={`${Links.IPO}`} element={<Ipo />} />
                <Route path={`${Links.SMEMARKET}`} element={<SME />} />
                <Route path={`${Links.SMEMARKET}/:slug`} element={<SMECat />} />

                <Route path={`${Links.INDICES}`} element={<Indices />} />
                <Route path={`${Links.INDICES}/:id`} element={<IndicesDetails />} />
                <Route path="*" element={<PageNotFound text='This page could not be found' />} />
                <Route path={`${Links.SCREENS}/create`} element={<Authentication><AddScreens /></Authentication>} />
                <Route path={`${Links.SUPERINVESTORS}`} element={<SuperInvestorList />} />
                <Route path={`${Links.INVESTOR}/:id`} element={<InvestorDetails />} />
                <Route path={`${Links.DEMOPORTFOLIO}/create`} element={<Authentication><AddDemoPortFolio /></Authentication>} />
                <Route path={`${Links.DEMOPORTFOLIO}`} element={<Demoportfolio />} />
                <Route path={`${Links.DEMOPORTFOLIO}/:id`} element={<DemoPortfolioDetails />} />
                <Route path={Links.CONTACT} element={<Contact />} />
                <Route path={Links.ABOUT} element={<About />} />
                <Route path={Links.PRIVACY} element={<Privacy />} />
                <Route path={Links.TERMS} element={<Terms />} />
                {/* add this 12-1-26 */}
                <Route path={`${Links.COMPANY}/:slug${Links.FORUM}`} element={<Authentication><ForumDetails /></Authentication>} />            
                <Route path={`${Links.FORUM}s`} element={<Authentication><ForumHome /></Authentication>} />
                {/* start add this 10-2-26 */}
                <Route path={`most-active-stocks/:range`} element={<MostActiveStocks />} />
                <Route path={`top-gainers/:range`} element={<TopGainers />} />
                <Route path={`top-losers/:range`} element={<TopLosers />} />
                <Route path={`most-active-stocks/:range/:sector`} element={<MostActiveStocks />} />
                <Route path={`top-gainers/:range/:sector`} element={<TopGainers />} />
                <Route path={`top-losers/:range/:sector`} element={<TopLosers />} />
                <Route path='/disclaimer' element={<Disclaimer />} />
                <Route path='/forum-posting-rules' element={<ForumRules />} />
                 {/* start add this 13-4-26 */}
                <Route path='/concalls' element={<AllConcalls />} />
                <Route path={`${Links.STOCKANALYSIS}`} element={<StockAnalysisVideo />} />
            </Routes>
        </Router>
    );
  };
  
  export default RoutePath;
  
